import { Action } from '@ngrx/store';

export const ActionTypes = {
    SET_APP_READY: '[App Ready Container] Set',
    SHOW_FOOTER_UPDATE: '[Show footer Container] Update'
};

export class UpdateShowFooter implements Action {
    type = ActionTypes.SHOW_FOOTER_UPDATE;
    payload: boolean;

    public constructor(showFooter: boolean) {
        this.payload = showFooter;
    }
}

export class SetAppReady implements Action {
    type = ActionTypes.SET_APP_READY;
}
